"use client";

import { useEffect, useRef, useState } from "react";
import cn from "clsx";

import type { SponsoredBannerData } from "../../types/ads/sponsoredBanner";

import styles from "./SponsoredBanner.module.scss";

const SponsoredBanner = ({
  data,
  hasMargin = true,
}: {
  data: SponsoredBannerData;
  hasMargin?: boolean;
}) => {
  const [isFloating, setIsFloating] = useState(false);
  const referenceRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const reference = referenceRef.current;
    if (!reference) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsFloating(!entry.isIntersecting),
      { threshold: 0, rootMargin: "-10px" },
    );

    observer.observe(reference);
    return () => observer.disconnect();
  }, []);

  const { red, green, blue } = data.color || {};

  return (
    <>
      <div
        ref={referenceRef}
        data-is-sticky-sentinel="true"
        aria-hidden="true"
      />
      <a
        data-is-sticky="true"
        href={data.linkUrl}
        style={{
          backgroundImage: `url(${data.imageUrl})`,
          backgroundColor:
            red !== undefined && green !== undefined && blue !== undefined
              ? `rgb(${red},${green},${blue})`
              : undefined,
        }}
        className={cn(
          styles.sponsoredBanner,
          isFloating && styles.floating,
          hasMargin && styles.margin,
        )}
        target="_blank"
        rel="noreferrer"
      />
    </>
  );
};

export { SponsoredBanner };
